import React, { useEffect, useState, Fragment } from 'react';
import { PageHeader } from '../../../Common';
import { validateProperty, validate } from "../../Common";
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import services from '../service';
import groupServices from '../../Group/services';
import MenuItem from '@material-ui/core/MenuItem';
import $ from 'jquery';
import { LoadingSpinerComponent } from '../../../Common/loader'
import { trackPromise } from 'react-promise-tracker';
import Joi from '@hapi/joi'
import { TextField,Grid } from '@material-ui/core';
import FormHelperText from '@material-ui/core/FormHelperText';
import authService from '../../Common/services';
import tokenService from '../../../Common/tokenDecoder';
import { CommonEncryptParam } from '../../../../utils/CommonParams';
import { SupplierListingSchemaObject } from '../SupplierSchema';
import { TableContent } from '../../Common/Table/tableContent';
import { AlertDialog } from '../../../Common/AlertDialog'; 


const screenCode = 'EXPORTSUPPLIERCREATION'

export function Listing(props) {
    const [suppliers, setSuppliers] = useState([]);
    const [supplierSearchData, setSupplierSearchData] = useState({
        groupID: 0,
        operationEntityID: 0,
        registrationNumber: '',
        NIC: ''

    });
    const [operationEntities, setOperationEntities] = useState([]);
    const [groups, setGroups] = useState();
    const [isTableHide, setIsTableHide] = useState(true);
    const contentRowNames = ["customerCode", "supplierName"]
    const [errors, setErrors] = useState({});
    const [permissionList, setPermissions] = useState({
        isAddEditEnabled: false,
        isGroupFilterEnabled: false,
        isOperationEntityFilterEnabled: false
    });
    const schema = Joi.object(SupplierListingSchemaObject).options({ allowUnknown: true });

    // //POPUp start
    const [message, setMessage] = useState("Edit Confirmation");
    const [EnableConfirmMessage, setEnableConfirmMessage] = useState(false);
   // //popUP end
    useEffect(() => {
        trackPromise(
            getPermissions()
        )
    }, []);

    useEffect(() => {
        trackPromise(
            getOperationEntities()
        )
    }, [supplierSearchData.groupID]);

    useEffect(() => {
        trackPromise(
            handleSearch()
        )
    }, [supplierSearchData.operationEntityID]);

    //POPUP function
    async function handleDelete() {
        setEnableConfirmMessage(true);
    }
    function confirmData(y) {
        if (y) {
          onCancelClick();
        }
    }
    //popUP End


    async function getPermissions() {

        var permissions = await authService.getPermissionsByScreen(screenCode);

        var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWEXPORTSUPPLIERCREATION');

        if (isAuthorized === undefined) {
            props.history.push('/unauthorized');
        }

        var isAddEditEnabled = permissions.find(p => p.permissionCode == 'ADDEDITEXPORTSUPPLIERCREATION');
        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');
        var isOperationEntityFilterEnabled = permissions.find(p => p.permissionCode == 'OPERATIONENTITYDROPDOWN');

        setPermissions({
            ...permissionList,
            isAddEditEnabled: isAddEditEnabled !== undefined,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isOperationEntityFilterEnabled: isOperationEntityFilterEnabled !== undefined
        });

        var token = tokenService.getUserDetailsFromToken();
        setSupplierSearchData({
            ...supplierSearchData,
            groupID: token.groupID,
            operationEntityID: token.operationEntityID
        });

        getAllGroups();
    }

    async function getOperationEntities() {
        var data = await services.getMultiCropsByGroupID(supplierSearchData.groupID);
        setOperationEntities(data);
    }

    async function getAllGroups() {
        const result = await groupServices.getGroupsForDropdown()
        setGroups(result);
    }

    function destroyDataTable() {
        $('#example').DataTable().destroy();
    }

    function createDataTable() {
        $('#example').DataTable();
    }

    function handleSupplierClick(supplier) {
        props.history.push({
            pathname: 'exportSupplier/supplierAddEdit/' + CommonEncryptParam(supplier.customerID.toString()),
            edit: true,
        });
    }

    function generateDropDownMenu(data) {
        let items = [];
        if (data != null) {
            for (const [key, value] of Object.entries(data)) {
                items.push(<MenuItem key={key} value={key}>{value}</MenuItem>);
            }
        }
        return items;
    }

    async function handleSearch(e) {

        if (e !== undefined) {
            const errorMessages = validate(schema, supplierSearchData);
            errorMessages !== null ? setErrors(errorMessages) : setErrors({});
            if (errorMessages) return;
        }

        const response = await services.GetSupplierDetails(supplierSearchData);

        var res = response.filter((v,i,a)=>a.findIndex(t=>(t.customerID === v.customerID))===i)

        setIsTableHide(false);
        destroyDataTable();
        setSuppliers(res);
        createDataTable();
    }

    function handleChange(target) {
        validateInputs(target);

        setSupplierSearchData({
            ...supplierSearchData,
            [target.name]: target.value
        });

    }

    function handleGroupDropdown(target) {
        validateInputs(target);

        setSupplierSearchData({
            ...supplierSearchData,
            groupID: target.value,
            operationEntityID: '0'
        });
    }

    function handleOperationEntityDropdown(target) {
        validateInputs(target);

        setSupplierSearchData({
            ...supplierSearchData,
            operationEntityID: target.value,
        });
    }

    function validateInputs(target) {
        const error = { ...errors };
        const errorMessage = validateProperty(target, SupplierListingSchemaObject);
        errorMessage ? error[target.name] = errorMessage : delete error[target.name];

        setErrors(error);
    }

    function clearState() {
        setSupplierSearchData({
            ...supplierSearchData,
            groupID: '0',
            operationEntityID: '0',
            collectionPointID: '0',
            aspNetUserID: '0',
        });
        destroyDataTable();
        setSuppliers([]);
        setIsTableHide(true);
    }

    function onCancelClick() {
        clearState();
    }

    return (
        <Fragment>
            <LoadingSpinerComponent />
            <div className="row">
                <div className="col-md-12">
                    <div className="card">
                        <div className="card-body">
                            <div className="row">
                                <PageHeader
                                    title="Supplier TS"
                                    isButtonEnable={permissionList.isAddEditEnabled}
                                    buttonText="Add Supplier"
                                    path="exportSupplier/supplierAddEdit" />
                            </div>
                            <hr />
                            <form>
                                <div className="form-group row">
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="groupID">Group ID *</InputLabel>
                                        <Select
                                            fullWidth
                                            id="groupID"
                                            disabled={!permissionList.isGroupFilterEnabled}
                                            name="groupID"
                                            value={supplierSearchData.groupID}
                                            onChange={(e) => handleGroupDropdown(e.target)}>
                                            <MenuItem value="0">--Select Group--</MenuItem>
                                            {generateDropDownMenu(groups)}
                                        </Select>
                                        {errors["groupID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["groupID"]}</FormHelperText>}
                                    </div>
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="operationEntityID">Company *</InputLabel>
                                        <Select
                                            fullWidth
                                            id="operationEntityID"
                                            disabled={!permissionList.isOperationEntityFilterEnabled}
                                            name="operationEntityID"
                                            value={supplierSearchData.operationEntityID}
                                            onChange={(e) => handleOperationEntityDropdown(e.target)}>

                                            <MenuItem value="0">--Select Company--</MenuItem>
                                            {generateDropDownMenu(operationEntities)}
                                        </Select>
                                        {errors["operationEntityID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["operationEntityID"]}</FormHelperText>}
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <div className="col-md">
                                        <TextField fullWidth label="Registration Number"
                                            name="registrationNumber"
                                            id="registrationNumber"
                                            value={supplierSearchData.registrationNumber}
                                            type="text"
                                            onChange={(e) => handleChange(e.target)} />
                                    </div>
                                    <div className="col-md">
                                        <TextField fullWidth label="NIC"
                                            name="NIC"
                                            id="NIC"
                                            value={supplierSearchData.NIC}
                                            type="text"
                                            onChange={(e) => handleChange(e.target)} />
                                    </div>
                                </div>
                                <div className="card-footer">
                                    <input
                                        disabled={validate(schema, supplierSearchData)}
                                        type="button"
                                        className="btn btn-primary"
                                        onClick={(e) => trackPromise(handleSearch(e))}
                                        value="Search"
                                    />
                                    <input
                                        type="button"
                                        className="btn btn-warning pull-right"
                                        value="Clear"
                                        onClick={handleDelete}
                                    />
                                </div>
                            </form>
                            <div className="table-responsive row-top-gap" >
                                <table id="example" className="display dataTable no-footer" hidden={isTableHide}>
                                    <thead>
                                        <tr>
                                            <th>Supplier Code</th>
                                            <th>Supplier Name</th>
                                            {permissionList.isAddEditEnabled ? <th>Actions</th> : null}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <TableContent
                                            data={suppliers}
                                            contentRowNames={contentRowNames}
                                            hasEdit={permissionList.isAddEditEnabled}
                                            handleClick={handleSupplierClick}
                                        />
                                    </tbody>
                                </table>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
            {/* popUP Start */}
            <div hidden={true}>
                <Grid item>
                    <AlertDialog confirmData={confirmData} headerMessage={message} viewPopup={EnableConfirmMessage}
                        discription={"Are you sure want to Edit "} setViewPopup={setEnableConfirmMessage} />
                </Grid>
            </div>
            {/* popup end */}
        </Fragment>
    )


}